const BaseError = require('make-error').BaseError;

class PageRangeError extends BaseError {
    constructor(errorMessage='Page number is out of range', rangeData) {
        super(errorMessage);
        if (!rangeData){
            throw new Error('You must specify range information in the form {firstDocumentRequested, lastDocumentRequested, totalDocuments}');
        }
        this._rangeData = rangeData;
    }
    get rangeData() {
        return this._rangeData;
    }
}

module.exports = PageRangeError;
